// Generated by tools/mockup-extract from the mockup NAV — do not hand-edit.
export interface NavItem { label: string; route: string; }
export interface NavGroup { key: string; label: string; labelAr: string; items: NavItem[]; }
export const NAV: NavGroup[] = [
  { key: 'dash', label: "Dashboards", labelAr: "لوحات المتابعة", items: [
    { label: "Stores operations", route: '/dash/stores' },
    { label: "Procurement", route: '/dash/proc' },
    { label: "Repair & overhaul", route: '/dash/mro' },
    { label: "Loans", route: '/dash/loans' },
    { label: "Quality & monitoring", route: '/dash/quality' },
    { label: "Management", route: '/dash/mgmt' },
  ] },
  { key: 'inv', label: "Stores", labelAr: "المستودعات", items: [
    { label: "Stock on hand", route: '/inv/stock' },
    { label: "Stock items (S/N & lots)", route: '/inv/items' },
    { label: "Stock ledger", route: '/inv/ledger' },
    { label: "Issue counter (scan)", route: '/inv/counter' },
    { label: "Issue notes", route: '/inv/issues' },
    { label: "Return notes", route: '/inv/returns' },
    { label: "Tags (S/V · U/S)", route: '/inv/tags' },
    { label: "Transfers", route: '/inv/transfers' },
    { label: "Adjustments", route: '/inv/adjustments' },
    { label: "Stock count", route: '/inv/count' },
    { label: "Labels", route: '/inv/labels' },
    { label: "Scan mode (mobile)", route: '/inv/scan' },
  ] },
  { key: 'dmd', label: "Demand", labelAr: "الطلبات", items: [
    { label: "Demand forms", route: '/dmd/list' },
    { label: "Generate from min levels", route: '/dmd/generate' },
    { label: "Demand board", route: '/dmd/board' },
  ] },
  { key: 'proc', label: "Procurement", labelAr: "المشتريات", items: [
    { label: "Purchase RFQ letters", route: '/proc/rfqs' },
    { label: "Supplier quotations", route: '/proc/quotes' },
    { label: "Quote comparison", route: '/proc/compare' },
    { label: "Purchase orders", route: '/proc/pos' },
    { label: "PO tracker", route: '/proc/tracker' },
  ] },
  { key: 'rcv', label: "Receiving", labelAr: "الاستلام", items: [
    { label: "Receiving vouchers (RV)", route: '/rcv/list' },
    { label: "Inspection", route: '/rcv/inspect' },
    { label: "Put-away (scan)", route: '/rcv/putaway' },
    { label: "Discrepancies", route: '/rcv/disc' },
  ] },
  { key: 'mro', label: "Repair & overhaul", labelAr: "الإصلاح والعمرة", items: [
    { label: "U/S backlog", route: '/mro/backlog' },
    { label: "Repair RFQ letters", route: '/mro/rfqs' },
    { label: "Repair orders", route: '/mro/ros' },
    { label: "Delivery notes", route: '/mro/dns' },
    { label: "At-vendor tracker", route: '/mro/vendor' },
    { label: "Warranty claims", route: '/mro/warranty' },
    { label: "Calibration", route: '/mro/cal' },
  ] },
  { key: 'loan', label: "Loans", labelAr: "الإعارة", items: [
    { label: "Loans", route: '/loan/list' },
    { label: "Loan request (we borrow)", route: '/loan/request' },
    { label: "Loan issue (we lend)", route: '/loan/issue' },
    { label: "Outstanding loans", route: '/loan/outstanding' },
  ] },
  { key: 'mon', label: "Monitoring", labelAr: "المتابعة", items: [
    { label: "Shelf life", route: '/mon/shelf' },
    { label: "Calibration due", route: '/mon/cal' },
    { label: "Open POs", route: '/mon/po' },
    { label: "Open repair orders", route: '/mon/ro' },
    { label: "Discrepancies", route: '/mon/disc' },
    { label: "Warranty", route: '/mon/wty' },
    { label: "Loans due", route: '/mon/loan' },
    { label: "Alert inbox", route: '/mon/alerts' },
  ] },
  { key: 'wf', label: "Approvals", labelAr: "الاعتمادات", items: [
    { label: "My approvals", route: '/wf/inbox' },
    { label: "Approval history", route: '/wf/history' },
    { label: "Delegations", route: '/wf/delegations' },
    { label: "Workflow definitions", route: '/wf/defs' },
    { label: "Approval matrix", route: '/wf/matrix' },
  ] },
  { key: 'mdm', label: "Master data", labelAr: "البيانات الرئيسية", items: [
    { label: "Parts", route: '/mdm/parts' },
    { label: "Suppliers & partners", route: '/mdm/partners' },
    { label: "Aircraft & engines", route: '/mdm/aircraft' },
    { label: "Stores & locations", route: '/mdm/locations' },
    { label: "Lookups", route: '/mdm/lookups' },
    { label: "Work orders", route: '/mdm/wo' },
  ] },
  { key: 'admin', label: "Administration", labelAr: "الإدارة", items: [
    { label: "Users", route: '/admin/users' },
    { label: "Roles & permissions", route: '/admin/roles' },
    { label: "Number series", route: '/admin/series' },
    { label: "Company & signatories", route: '/admin/company' },
    { label: "Settings", route: '/admin/settings' },
    { label: "Label templates & printers", route: '/admin/labels' },
    { label: "Alert rules", route: '/admin/alerts' },
    { label: "Audit log", route: '/admin/audit' },
    { label: "Data import", route: '/admin/import' },
  ] },
];
